import React from 'react';
import './Badge.css';

interface BadgeProps {
  data: any;
}

const Badge: React.FC<BadgeProps> = ({ data }) => {
  return (
    <div className={data=='E' ? "badge-e" : "badge"}>
      <span className={data=='E' ? "badge-content-e" : "badge-content"}>{data}</span>
    </div>
  )
}

export default Badge;
